import React from "react";
import { Row, Col, Container, Accordion, Offcanvas, Image, Stack, Button, InputGroup, Form, Dropdown } from "react-bootstrap";
import { Navbar, Nav, NavLink } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ParentCategory from "../components/menus/parent-category";
import { UserIcon } from "../components/icons/icons";
const HeaderMobile = ({ searchProductList, showSearch, offCanvasShow, setOffCanvasShow, categoryList, setgMapModalShow, logo, user, token, setLoginModalShow, handleProductSearch, cartCount }) => {

    return (
        <header className="d-block d-sm-none">
            <Row className="App-header px-0">
                <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary p-0">
                    <Container>
                        <Col xs="2" className="">
                            <Navbar.Toggle className="border-0" aria-controls="responsive-navbar-nav" onClick={() => setOffCanvasShow(!offCanvasShow)} />

                            <Navbar.Offcanvas
                                placement="end"
                                show={offCanvasShow}
                                id={`offcanvasNavbar-expand-nav`}
                                aria-labelledby={`offcanvasNavbarLabel-expand-nav`}

                            >
                                <Offcanvas.Header>
                                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-nav`}>
                                        Categories
                                    </Offcanvas.Title>
                                    <span className="ms-auto" onClick={() => setOffCanvasShow(!offCanvasShow)}><FontAwesomeIcon icon="fa-solid fa-xmark" size="xl" /></span>
                                </Offcanvas.Header>
                                <Offcanvas.Body style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 120px)' }}>
                                    <Nav className="justify-content-end flex-grow-1 pe-3">
                                        <Accordion defaultActiveKey="0">
                                            {categoryList &&
                                                categoryList.data.map((category, index) => (
                                                    <ParentCategory
                                                        items={category}
                                                        keys={index}
                                                        key={index}
                                                        setOffCanvasShow={setOffCanvasShow}
                                                    />
                                                ))}
                                        </Accordion>
                                    </Nav>
                                </Offcanvas.Body>
                            </Navbar.Offcanvas>
                        </Col>
                        <Col xs="2" className="logo text-start" onClick={() => setgMapModalShow(true)}><FontAwesomeIcon
                            icon="fa-solid fa-location-dot"
                            size="xl"
                            style={{ cursor: "pointer" }}
                        /></Col>
                        <Col xs="3" className="logo text-start">
                            <Nav.Link href="/">
                                <Image src={logo} />
                            </Nav.Link>
                        </Col>
                        <Col xs="3" className="profile">
                            <Stack className="text-start gap-1" direction="horizontal">
                                <UserIcon />
                                {!user || !token ? (
                                    <Button
                                        variant="link"
                                        className="p-0 ULText text-decoration-none btn-bg-none text-start"
                                        onClick={() => setLoginModalShow(true)}
                                    >
                                        Login
                                    </Button>
                                ) : (
                                    <NavLink className="dropdown-item h-b" href="/profile">
                                        {user.name ? user.name : "View Account"}
                                    </NavLink>)
                                }
                            </Stack>
                        </Col>
                        <Col xs="2" className="cart">
                            <Nav.Link href="/cart">
                                <Stack direction="horizontal" gap={1}>
                                    <div className="ciDiv">
                                        <FontAwesomeIcon icon="fa-solid fa-cart-shopping" size="lg" />
                                    </div>
                                    <span className="hitemTxt w-100 ">
                                        {cartCount}
                                    </span>

                                </Stack>
                            </Nav.Link>
                        </Col>
                    </Container>
                </Navbar>
            </Row>
            <Row>
                <Col className="d-flex align-items-center p-0">
                    <Col xs="12" className="position-relative">
                        <InputGroup>
                            <div className="search-icon">
                                <FontAwesomeIcon
                                    className="form-control-feedback"
                                    icon="fa-solid fa-search"
                                    size="1x"
                                />
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Search for products..."
                                className=" mr-sm-2 bg-light searchBox"
                                onChange={handleProductSearch}
                            />
                        </InputGroup>
                        {showSearch && (
                            <Dropdown.Menu show className="w-100 position-absolute">
                                {searchProductList &&
                                    searchProductList.map((pl, index) => (
                                        <Dropdown.Item
                                            eventKey={index}
                                            className="td-none"
                                            href={`/pd/${pl.slug}`}
                                        >
                                            {pl.productName}-{pl.unit}
                                            {pl.unitName}
                                        </Dropdown.Item>
                                    ))}
                            </Dropdown.Menu>
                        )}
                        {!showSearch && (
                            <Dropdown.Menu hide className="w-100 position-absolute">
                                {" "}
                            </Dropdown.Menu>
                        )}
                    </Col>
                </Col>
            </Row>
        </header>
    );
};

export default HeaderMobile;
